import { render, staticRenderFns } from "./EducationalStageDelete.vue?vue&type=template&id=fa4d3c28&"
import script from "./EducationalStageDelete.vue?vue&type=script&lang=js&"
export * from "./EducationalStageDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports